import React, { useEffect, useMemo, useState } from 'react';
import { getImageSrcCandidates } from '@/utils/mediaUrl';

/**
 * Image that works with Google Drive share links.
 * - Converts /view links via resolveMediaUrl
 * - Uses referrerPolicy="no-referrer" (Drive blocks many hotlinks with a Referer)
 * - Falls back through alternate Drive URL formats on error
 */
export function MediaImage({ src, alt = '', className, onLoad, onError, ...props }) {
  const candidates = useMemo(() => getImageSrcCandidates(src), [src]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [src]);

  const current = candidates[index] || '';
  if (!current) return null;

  return (
    <img
      src={current}
      alt={alt}
      className={className}
      referrerPolicy="no-referrer"
      loading="lazy"
      onLoad={onLoad}
      onError={(e) => {
        if (index < candidates.length - 1) {
          setIndex((i) => i + 1);
          return;
        }
        onError?.(e);
      }}
      {...props}
    />
  );
}
